<template>

  <nav class="sb-topnav navbar navbar-expand navbar-dark bg-dark" v-if="$store.getters.user.loggedIn">

    <router-link class="navbar-brand" to="/">KPSS 2021</router-link>
    <button class="btn btn-link btn-sm order-1 order-lg-0" id="sidebarToggle" href="#" @click="showHide"><i class="fas fa-bars"></i></button>
    <!-- Navbar Search-->
    <form class="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-3 my-2 my-md-0" >
      <div class="input-group" v-show="$router.currentRoute.value.name!=='Home'">
        <input class="form-control" type="text" v-model="search" placeholder="İçerikte Ara" @keyup="searchChanged" aria-label="Search" aria-describedby="basic-addon2" />

      </div>
    </form>
    <!-- Navbar-->
    <ul class="navbar-nav ml-auto ml-md-0">
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" id="userDropdown" href="#" @click="showProfile=!showProfile" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-user fa-fw"></i></a>
        <div class="dropdown-menu dropdown-menu-right " :class="showProfile?'show':''" aria-labelledby="userDropdown">
          <a class="dropdown-item" href="#" @click="logOut">Çıkış</a>
        </div>
      </li>
    </ul>
  </nav>

</template>

<script>
import firebase from 'firebase'
export default {
  name: 'Header',
  data () {
    return {
      show: true,
      search: '',
      showProfile: false
    }
  },
  methods: {
    showHide () {
      this.show = !this.show
      if (!this.show) {
        document.body.classList.add('sb-sidenav-toggled')
      } else {
        document.body.classList.remove('sb-sidenav-toggled')
      }
    },
    searchChanged () {
      this.$emit('searchchange', this.search)
    },
    logOut () {
      const self = this
      firebase.auth().signOut().then(function () {
        self.$router.push('/login')
      })
    }
  }
}
</script>

<style scoped>

</style>
